module.exports = __webpack_public_path__ + "img/in.51d18691.svg";